import { render } from "./ColorClipboardView.vue?vue&type=template&id=2b091804&scoped=true"
import script from "./ColorClipboardView.vue?vue&type=script&lang=js"
export * from "./ColorClipboardView.vue?vue&type=script&lang=js"

import "./ColorClipboardView.vue?vue&type=style&index=0&id=2b091804&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b091804"]])

export default __exports__